import React from 'react';
import RecipeBody from './body.tsx';
import RecipeHeader from './header.tsx';
import { useParams } from 'react-router-dom';
import { RecipeContextProvider } from '../../../contexts/recipes/recipe.tsx';

const Recipe = () => {
    const { id } = useParams();
    return (
        <RecipeContextProvider id={id}>
            <RecipeHeader />
            <RecipeBody />
        </RecipeContextProvider>
    );
};

export default Recipe;
